// Display rules for the "Source" / "Vintage" columns of the MCP Usage Activity
// table. dataSource is summarized by the backend from per-section entries.
const STYLES = {
  geoenrichment: { label: 'GeoEnrichment', color: '#1b5e20', background: '#e8f5e9' },
  legacy: { label: 'Legacy', color: '#8a4b00', background: '#fff3e0' },
  mixed: { label: 'Mixed', color: '#0d47a1', background: '#e3f2fd' },
  'n/a': { label: 'n/a', color: '#616161', background: '#f5f5f5' },
  unknown: { label: 'Unknown', color: '#616161', background: '#f5f5f5' },
};

export function sourceChipProps(dataSource) {
  if (!dataSource) return { label: '—', color: '#9e9e9e', background: 'transparent' };
  return STYLES[dataSource] || STYLES.unknown;
}

export function vintageText(dataVintage) {
  return dataVintage || '—';
}

// Per-section detail for the hover tooltip, e.g. "income: geoenrichment (2026)".
export function provenanceTooltip(log) {
  const entries = Array.isArray(log && log.dataProvenance) ? log.dataProvenance : [];
  if (entries.length === 0) return 'No provenance recorded for this call';
  return entries
    .map(e => {
      const name = e.section || 'result';
      const year = e.vintage ? ` (${e.vintage})` : '';
      return `${name}: ${e.source || 'unknown'}${year}`;
    })
    .join('\n');
}
